export function OrganizationOnboarding(organizationID: number): string {
	return `/v1/organizations/${organizationID}/task-lists/organization-onboarding`;
}

export function RemoveOrganizationOnboardingFlag(organizationID: number): string {
	return `/v1/organizations/${organizationID}/task-lists/organization-onboarding-flag`;
}

